import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { fonts, themes } from "../themes/themes";

interface contentTileType {
  tile_key: string;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
  onClick?: any;
}
const CardForOnclick: React.FC<contentTileType> = ({
  tile_key,
  onClick,
  value_color = themes.tileValue_black,
  key_color = themes.tileKey_grey,
  is_bold = false,
}) => {
  return (
    <Grid
      container
      style={{
        marginTop: "12px",
        width: "auto",
        height: "37px",
        paddingLeft: "23px",
        paddingRight: "23px",
        paddingTop: "10px",
        paddingBottom: "10px",
        backgroundColor: "#fafafa",
        borderRadius: "6px",
        opacity: 1,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <Grid
        item
        style={{
          flexGrow: 1,
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: "#7C0E6F",
          textTransform: "capitalize",
          fontWeight: is_bold ? "bolder" : "normal",
        }}
      >
        {tile_key}
      </Grid>
      <Grid
        item
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          textAlign: "right",
          textTransform: "capitalize",
          fontWeight: is_bold ? "bolder" : "normal",
        }}
      >
        <i className="las la-angle-right"></i>
      </Grid>
    </Grid>
  );
};

export default CardForOnclick;
